'use client';
import React from 'react';
import LegalPageShell from '@/components/LegalPageShell';
import TermsOfServiceContent from './components/TermsOfServiceContent';

export default function TermsOfServicePage() {
  return (
    <LegalPageShell>
      <TermsOfServiceContent />
    </LegalPageShell>
  );
}
